/**
 * Badge component - Reusable badge/tag
 */
import React from 'react';

const Badge = ({
  children,
  variant = 'primary',
  className = '',
  pill = false,
  size = 'md'
}) => {
  const sizeClass = size === 'sm' ? 'badge-sm' : size === 'lg' ? 'badge-lg' : '';
  const pillClass = pill ? 'rounded-pill' : '';

  return (
    <span className={`badge bg-${variant} ${sizeClass} ${pillClass} ${className}`}>
      {children}
    </span>
  );
};

export default Badge;
